import React from "react";
import {
  MapContainer,
  TileLayer,
  Polyline,
  Marker,
  Popup,
} from "react-leaflet";

import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet-defaulticon-compatibility";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import moment from "moment/moment";

const AgentRouteMap = ({ locations, visits, session }) => {
  // console.log("locations in route map ", visits);
  console.log("session in route map ", session);

  console.log(
    session?.checkInTime
      ? moment.utc(session?.checkInTime).local().format("hh:mm A")
      : "-",
  );

  if (!locations || locations.length === 0) {
    return <div className="text-center p-5">No route data available</div>;
  }

  // 1. Sort by time to ensure it strictly chains chronologically
  const chronologicalLocations = [...locations].sort(
    (a, b) => new Date(a.recordedAt) - new Date(b.recordedAt),
  );

  // 2. Filter out heavy noise while keeping consecutive path steps clean
  const filteredLocations = chronologicalLocations.filter(
    (item, index, arr) => {
      if (item.accuracy > 50 && index > 0 && index < arr.length - 1) {
        return false;
      }
      return true;
    },
  );

  if (filteredLocations.length === 0) {
    return <div className="text-center p-5">No valid GPS points found</div>;
  }

  // 3. Chain coordinates sequentially: [[lat1, lng1], [lat2, lng2], ...]
  const coordinates = filteredLocations.map((item) => [
    item.latitude,
    item.longitude,
  ]);

  const start = filteredLocations[0];
  const end = filteredLocations[filteredLocations.length - 1];
  const hasMoved = coordinates.length > 1;

  // Calculate the middle point of your route to keep the camera perfectly balanced
  const middleIndex = Math.floor(coordinates.length / 2);
  const mapCenter = [coordinates[middleIndex][0], coordinates[middleIndex][1]];

  return (
    <MapContainer
      center={mapCenter}
      zoom={15} // Increased to 19 (Maximum close-up street view zoom for OpenStreetMap)
      maxZoom={20}
      scrollWheelZoom={true}
      style={{
        width: "100%",
        height: "400px",
      }}
    >
      <TileLayer
        attribution="&copy; OpenStreetMap"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        maxZoom={19} // Ensures tile engine loads up to max close-up assets
      />

      {/* Renders the chained path segments */}
      {hasMoved && (
        <Polyline
          positions={coordinates}
          pathOptions={{
            color: "#1E88E5",
            weight: 5,
            opacity: 0.85,
            lineJoin: "round",
          }}
        />
      )}

      {/* Start Point Marker */}
      <Marker
        position={[start.latitude, start.longitude]}
        icon={L.divIcon({
          className: "",
          html: "<span style='font-size: 15px; filter: drop-shadow(0px 2px 2px rgba(0,0,0,0.3));'>🟢</span>",
          iconSize: [24, 24],
          iconAnchor: [12, 12],
        })}
      >
        <Popup>
          <div>
            <strong>Start Point</strong>
            <br />
            {/* {moment.utc(start.recordedAt).local().format("hh:mm A")} */}
            {session?.checkInTime
              ? moment.utc(session?.checkInTime).local().format("hh:mm A")
              : "-"}
          </div>
        </Popup>
      </Marker>

      {/* End Point Marker */}
      {hasMoved && (
        <Marker
          position={[end.latitude, end.longitude]}
          icon={L.divIcon({
            className: "",
            html: "<span style='font-size: 13px; filter: drop-shadow(0px 2px 2px rgba(0,0,0,0.3));'>🔴</span>",
            iconSize: [24, 24],
            iconAnchor: [12, 12],
          })}
        >
          <Popup>
            <div>
              <strong>End Point</strong>
              <br />
              {moment.utc(end.recordedAt).local().format("hh:mm A")}
            </div>
          </Popup>
        </Marker>
      )}

      {/* Visit Markers */}
      {visits?.map((visit, index) => (
        <Marker
          key={visit.visitId || index}
          position={[visit.location.latitude, visit.location.longitude]}
          icon={L.divIcon({
            className: "",
            html: `
        <div style="
          width:18px;
          height:18px;
          background:#FF9800;
          border:2px solid #fff;
          border-radius:50%;
          box-shadow:0 0 4px rgba(0,0,0,.4);
        "></div>
      `,
            iconSize: [18, 18],
            iconAnchor: [9, 9],
          })}
        >
          <Popup>
            <div>
              <strong>{visit.farmerName}</strong>
              <br />
              {visit.location.address
                ? visit.location.address.split("•")[0].trim()
                : "Address not available"}
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default AgentRouteMap;
